<div class="ranking">
    <div class="ranking__header">
        <span class="ranking__header-label">{{ "data_entry.performance" | translate }}</span>
    </div>

    <div class="ranking__rows">
        @if (showAverage()) {
            <div class="ranking__average-layer">
                <span class="ranking__average-column">
                    <span class="ranking__average" [style.inset-inline-start.%]="averagePercentage()">
                        <span class="ranking__average-pill-anchor">
                            <span class="ranking__average-pill">{{ "common.form.label.average" | translate }} {{ averageText() }}</span>
                        </span>
                    </span>
                </span>
            </div>
        }

        @for (entity of topEntities(); track entity.id) {
            <ng-template #rowTooltip>
                <span class="ranking__tip">
                    <span class="ranking__tip-title">
                        <span class="ranking__tip-swatch" [style.background]="entity.color"></span>
                        {{ entity.name }}
                    </span>
                    <span>
                        {{ "executive_dashboard.rank" | translate }}: {{ entity.rank }} <br />
                        {{ "data_entry.performance" | translate }}: {{ entity.valueText }}
                    </span>
                </span>
            </ng-template>

            <div class="ranking__row" container="body" placement="top" [ngbTooltip]="rowTooltip">
                <span class="ranking__rank">{{ entity.rank }}</span>
                <span class="ranking__name">{{ entity.name }}</span>
                <span class="ranking__track">
                    <span class="ranking__bar" [style.width.%]="entity.percentage" [style.background]="entity.color"></span>
                </span>
                <span class="ranking__value" [style.color]="entity.color">{{ entity.valueText }}</span>
            </div>
        }
    </div>

    @if (remainingEntities().length > 0) {
        <div class="ranking__rest">
            <button type="button" class="btn btn-link btn-sm fw-bold p-0 text-decoration-none" (click)="toggleRest()">
                @if (showRest()) {
                    {{ "landingPage.entity_page.hide_remaining_entities" | translate }}
                } @else {
                    {{ "landingPage.entity_page.show_remaining_entities" | translate }}
                }
                ({{ remainingEntities().length }})
            </button>

            @if (showRest()) {
                <div class="ranking__rest-grid">
                    @for (entity of remainingEntities(); track entity.id) {
                        <ng-template #restTooltip>
                            <span class="ranking__tip">
                                <span class="ranking__tip-title">
                                    <span class="ranking__tip-swatch" [style.background]="entity.color"></span>
                                    {{ entity.name }}
                                </span>
                                <span>
                                    {{ "executive_dashboard.rank" | translate }}: {{ entity.rank }} <br />
                                    {{ "data_entry.performance" | translate }}: {{ entity.valueText }}
                                </span>
                            </span>
                        </ng-template>

                        <div class="ranking__row ranking__row--compact" container="body" placement="top" [ngbTooltip]="restTooltip">
                            <span class="ranking__rank">{{ entity.rank }}</span>
                            <span class="ranking__name">{{ entity.name }}</span>
                            <span class="ranking__track">
                                <span class="ranking__bar" [style.width.%]="entity.percentage" [style.background]="entity.color"></span>
                            </span>
                            <span class="ranking__value" [style.color]="entity.color">{{ entity.valueText }}</span>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
